// extracted by mini-css-extract-plugin
module.exports = {"sliderArrow":"styles_sliderArrow__uBznL","leftArrow":"styles_leftArrow__dvsFU","inside":"styles_inside__a3Az5","rightArrow":"styles_rightArrow__epzEr"};